import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage, ref } from "firebase/storage";

const config = {
  apiKey: "AIzaSyDHbSqEBS7jm_CdHqkBvweIVmHRsLdBIms",
  authDomain: "freiwaldcup2023-7e6e7.firebaseapp.com",
  projectId: "freiwaldcup2023-7e6e7",
  storageBucket: "freiwaldcup2023-7e6e7.appspot.com",
  messagingSenderId: "893088216264",
  appId: "1:893088216264:web:4f7bc4dc5741bcbb00e1fd"
};

  export function getFirebaseConfig() {
    if (!config || !config.apiKey) {
      throw new Error('No Firebase configuration object provided.' + '\n' +
      'Add your web app\'s configuration object to firebase-config.ts');
    } else {
      return config;
    }
  } 

  const app = initializeApp(config);
  const auth = getAuth(app);
  const db = getFirestore();
  const storage = getStorage(app);
  
  export { auth, db, storage };
  export const storageRef = ref(storage, "images/"); 